import HelpAPI from '@/API/helpers/help-apis'

export default {
  namespaced: true,

  state: {
    sections: [],
    fetched: false,
  },

  getters: {
    questionSections: (state: any) => state.sections,
  },

  mutations: {
    SET_SECTIONS(state: any, sections: Array<any>) {
      state.sections = sections
      state.fetched = true
    },
  },

  actions: {
    async fetchHelpSections(context: any) {
      if (context.state.fetched) return context.state.sections

      const sections = await HelpAPI.sections()
      context.commit('SET_SECTIONS', sections)
      return sections
    },
  },
}
